var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17801_2117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.98438 11.1755C6.78793 11.1755 8.25 9.77992 8.25 8.05835C8.25 6.33677 6.78793 4.94116 4.98438 4.94116C3.18082 4.94116 1.71875 6.33677 1.71875 8.05835C1.71875 9.77992 3.18082 11.1755 4.98438 11.1755Z",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.343942 16.0974C0.332101 15.4622 0.451466 14.8311 0.695219 14.2399C0.938973 13.6488 1.30234 13.1093 1.76456 12.6522C2.22679 12.1952 2.77881 11.8295 3.38911 11.5761C3.99941 11.3228 4.65602 11.1866 5.32144 11.1755M9.96894 16.0974C9.98078 15.4622 9.86142 14.8311 9.61766 14.2399C9.37391 13.6488 9.01054 13.1093 8.54832 12.6522C8.0861 12.1952 7.53407 11.8295 6.92377 11.5761C6.31348 11.3228 5.65686 11.1866 4.99144 11.1755",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2942 6.17651H20.0589",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2942 10.5H20.0589",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2942 14.8236H20.0589",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17801_2117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact-info.0a1f9753ac6a66d4b1815da47bf3691c.svg";
export { ForwardRef as ReactComponent };